<template>
  <ExternalServiceConsentNotice
    v-if="!externalAllowed"
    message="Die Sicherheitsprüfung (Friendly Captcha) ist ein externer Dienst. Bitte aktivieren Sie „Externe Dienste“ in den Cookie-Einstellungen."
  />
  <div
    v-else
    ref="hostRef"
    class="frc-captcha app-modal-captcha"
    :class="{ dark: theme === 'dark' }"
  ></div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import { WidgetInstance } from 'friendly-challenge'
import { useCookieConsent } from '../../composables/useCookieConsent.js'
import ExternalServiceConsentNotice from './ExternalServiceConsentNotice.vue'

const FRIENDLY_CAPTCHA_SITEKEY = 'FCMKP25R6FB1G2O7'

export default {
  name: 'FriendlyCaptchaField',
  components: { ExternalServiceConsentNotice },
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: (value) => ['light', 'dark'].includes(value),
    },
  },
  emits: ['validated', 'error'],
  setup(props, { emit }) {
    const { externalAllowed } = useCookieConsent()
    const hostRef = ref(null)
    let widget = null

    const destroyWidget = () => {
      if (!widget) return
      try {
        widget.destroy()
      } catch (_) {
        /* DOM bereits entfernt */
      }
      widget = null
      if (hostRef.value) {
        hostRef.value.innerHTML = ''
      }
    }

    const initWidget = async () => {
      destroyWidget()
      emit('validated', false)

      if (!externalAllowed.value) return

      await nextTick()

      const element = hostRef.value
      if (!element) return

      widget = new WidgetInstance(element, {
        sitekey: FRIENDLY_CAPTCHA_SITEKEY,
        language: 'de',
        startMode: 'auto',
        doneCallback: (solution) => {
          emit('validated', Boolean(solution))
        },
        errorCallback: () => {
          emit('validated', false)
          emit(
            'error',
            'Die Sicherheitsprüfung konnte nicht geladen werden. Bitte Seite neu laden.'
          )
        }
      })
    }

    watch(externalAllowed, (allowed) => {
      if (allowed) {
        initWidget()
      } else {
        destroyWidget()
        emit('validated', false)
      }
    })

    onMounted(() => {
      if (externalAllowed.value) {
        initWidget()
      } else {
        emit('validated', false)
      }
    })

    onBeforeUnmount(() => {
      destroyWidget()
    })

    return { hostRef, externalAllowed }
  }
}
</script>

<style lang="scss" scoped>
:deep(.frc-banner) {
  display: none;
}

:deep(.frc-content) {
  text-align: left;
}
</style>
